import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=6d5386de&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"
import style0 from "./orders.vue?vue&type=style&index=0&id=6d5386de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5386de",
  null
  
)

export default component.exports